import { workload } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  getWorkloadList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(workload.workloadBase, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getWorkloadObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${workload.workloadBase}${id}/`)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  createWorkload(payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(workload.workloadBase, payload)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  addContainersToWorkload(id, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${workload.workloadBase}${id}/add_containers/`, payload)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getWorkloadDashboard(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${workload.workloadBase}dashboard/`, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getWorkloadDrillIn(date, locationCode = null) {
    const params = { date };
    if (locationCode) params.location_code = locationCode;
    return new Promise((resolve, reject) => {
      axios
        .get(`${workload.workloadBase}drill_in/`, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
});
